import { PaywallPopupReason } from '@nx-frontend/shared/types';
import { PaywallPlan } from '@nx-frontend/shared/types/paywall-types';

const FEATURE_REASON_START_PLANS: Partial<Record<PaywallPopupReason, string[]>> = {
  [PaywallPopupReason.NOTE_REVISIONS_POPUP]: ['team', 'team2024'],
  [PaywallPopupReason.SERVER_BACKUPS]: ['team', 'team2024'],
  [PaywallPopupReason.CNAME]: ['business2023', 'business2024'],
  [PaywallPopupReason.BRANDING]: ['team', 'team2024'],
  [PaywallPopupReason.LOCK_BLOTS]: ['team', 'team2024'],
  [PaywallPopupReason.MANAGE_MEMBERS_GRANULAR]: ['team', 'team2024'],
  [PaywallPopupReason.PORTAL_MANAGE_ACCESS_GRANULAR]: ['plus2024'],
  [PaywallPopupReason.INTEGRATIONS]: ['business2023', 'business2024'],
};

export function disablePlansByReason(plans: PaywallPlan[], reason: PaywallPopupReason) {
  if (!FEATURE_REASON_START_PLANS[reason]) return plans;

  let isEnabled = false;
  let enabledByReasoneIndex = -1;
  const newPlans = plans.map((plan, index) => {
    isEnabled = !isEnabled
      ? (FEATURE_REASON_START_PLANS[reason] as string[]).some((planCode) => plan.code.startsWith(planCode))
      : isEnabled;

    if (enabledByReasoneIndex === -1 && isEnabled) {
      enabledByReasoneIndex = index;
    }

    return {
      ...plan,
      disabled: !isEnabled,
    };
  });

  if (enabledByReasoneIndex !== -1) {
    newPlans[enabledByReasoneIndex].isRecommended = true;
    const mostPopular = newPlans.find((item) => item.isMostPopular);
    if (mostPopular) {
      mostPopular.isMostPopular = false;
    }
  }

  return newPlans;
}
